import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AggTransaction } from "../../models/AggTransaction";
import { fetchData, postData } from '../../services/ApiService';
import {
  closeCircularProgress,
  openCircularProgress,
} from "../uireducers/progress";
import { BetViewRequest } from "../../models/BetViewRequest";
import { BetView } from "../../models/BetView";
import { Day2DayTransRequest } from "../../models/Day2DayTransRequest";
import { CustBetHisotry } from "../../models/CustBetHistory";
import { BusinessReport } from "../../models/BusinessReport";
import { GameReport } from "../../models/GameReport";

// Add new interfaces
interface ReportRequest {
  gameId: number;
  date: string;
  resultTimeId: number;
  type: string;
}

interface SingleReportRequest {
  gameId: number;
  date: string;
  resultTimeId: number;
  type: string;
  reportSheetData: any
}


interface ReportData {
  value: string; 
  points: string;
}

// Logic to Get All Templates
export const getAggCustTransByDate = createAsyncThunk(
  "transactionEntity/getAggCustTransByDate",
  async ({date, agentId}: {date: string, agentId: number}, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await fetchData(`transactions/agg/${date}/${agentId}`); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);

export const getCustBetHistory = createAsyncThunk(
  "transactionEntity/getCustBetHistory",
  async (data, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await fetchData(`transactions/customers/betHistory`); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);

export const fetchGameReportAction = createAsyncThunk(
  "transactionEntity/fetchGameReportAction",
  async (data: any, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await postData(`transactions/gameReport`, data); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);


// Logic to Get All Templates
export const getBetViewReport = createAsyncThunk(
  "transactionEntity/getBetViewReport",
  async (request: BetViewRequest, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await postData(`transactions/betView`, request); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);

export const getDayTransactions = createAsyncThunk(
  "transactionEntity/getDayTransactions",
  async (request: Day2DayTransRequest, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await postData(`transactions/dayReport`, request); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);

export const getBusinessReport = createAsyncThunk(
  "transactionEntity/getBusinessReport",
  async (request: BetViewRequest, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await postData(`transactions/businessReport`, request); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);

export const savePattiReport = createAsyncThunk(
  "transactionEntity/savePattiReport",
  async (request: SingleReportRequest, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const response = await postData(`transactions/pattiReport`, request);
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue((error as Error)?.message || 'Request failed');
    }
  }
);

export const getSingleReport = createAsyncThunk(
  "transactionEntity/getSingleReport",
  async (request: ReportRequest, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const response = await fetchData(
        `transactions/singleReport/${request.gameId}/${request.date}/${request.resultTimeId}`
      );
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue((error as Error)?.message || 'Request failed');
    }
  }
);

export const saveSingleReport = createAsyncThunk(
  "transactionEntity/saveSingleReport",
  async (request: SingleReportRequest, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const response = await postData(`transactions/singleReport`, request);
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue((error as Error)?.message || 'Request failed');
    }
  }
);

export const getPattiReport = createAsyncThunk(
  "transactionEntity/getPattiReport",
  async (request: ReportRequest, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const response = await fetchData(
        `transactions/pattiReport/view/${request.gameId}/${request.date}/${request.resultTimeId}`
      );
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue((error as Error)?.message || 'Request failed');
    }
  }
);



const slice = createSlice({
  name: "transactionEntity",
  initialState: {
    aggTran: [] as AggTransaction[],
    betViews: [] as BetView[],
    custBetHisotry: [] as CustBetHisotry[],
    businessReports: [] as BusinessReport[],
    gameReport: {} as GameReport,
    pattiReport: null as ReportData | null,
    singleReport: null as ReportData | null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getAggCustTransByDate.fulfilled, (state, action) => {
      state.aggTran = action.payload;
    });
    builder.addCase(getBetViewReport.fulfilled, (state, action) => {
      state.betViews = action.payload;
    });
    builder.addCase(getDayTransactions.fulfilled, (state, action) => {
      state.aggTran = action.payload;
    });
    builder.addCase(getCustBetHistory.fulfilled, (state, action) => {
      state.custBetHisotry = action.payload;
    });

    builder.addCase(getBusinessReport.fulfilled, (state, action) => {
      state.businessReports = action.payload;
    });

    builder.addCase(fetchGameReportAction.fulfilled, (state, action) => {
      state.gameReport = action.payload;
    });

    builder
    .addCase(getPattiReport.fulfilled, (state, action) => {
      state.pattiReport = action.payload;
    })
    .addCase(getSingleReport.fulfilled, (state, action) => {
      state.singleReport = action.payload;
    });
  },
});

//export const { setSelectedUser } = slice.actions;

export default slice.reducer;